import React from 'react'
import styles from "../myprofile/myprofile.module.css"
import ProfileMenu from '../../Components/profilemenu/ProfileMenu'
import ReceivedEnquiresTab from '../../Components/allEnquiresTab/ReceivedEnquiresTab'
import Myprofile from '../myprofile/Myprofile'
import RecievedOrderTab from '../../Components/orderscomp/RecievedOrderTab'

const ReceivedOrders = () => {
    return (
        <>
            <Myprofile className={styles.myprofile}>
             
                <RecievedOrderTab />
            </Myprofile>
        </>
    )
}

export default ReceivedOrders